import React from 'react';

interface SummaryCardProps {
    icon: React.ReactNode;
    title: string;
    value: string | number;
}

export const SummaryCard: React.FC<SummaryCardProps> = ({ icon, title, value }) => {
    return (
        <div className="bg-white dark:bg-gray-800 border border-[#e6e6e6] dark:border-gray-700 rounded-[12.13px] p-[1.6px] min-w-0">
            <div className="flex items-center justify-between pt-3 sm:pt-[15px] px-3 sm:px-[19.5px] pb-0">
                <div className="flex flex-col items-start min-w-0 flex-1">
                    <p className="text-xs sm:text-[12px] font-semibold text-[#364153] dark:text-gray-300 leading-[16.25px] line-clamp-2">
                        {title}
                    </p>
                </div>
                <div className="bg-[#f2fcfa] dark:bg-emerald-900/30 rounded-[8.13px] p-1.5 sm:p-[6.5px] shrink-0 ml-2">
                    {icon}
                </div>
            </div>
            <div className="flex flex-col gap-0 items-start pb-3 sm:pb-[15px] pt-0 px-3 sm:px-[19.5px]">
                <div className="flex flex-col items-start w-full min-w-0">
                    <p className="text-lg sm:text-xl md:text-[24.4px] font-bold text-[#364153] dark:text-white leading-[29.25px]">
                        {value}
                    </p>
                </div>
            </div>
        </div>
    );
};


